
import {
  CheckIcon,
  PhoneIncomingIcon,
  ChatAltIcon,
  PlayIcon,
} from "@vue-hero-icons/outline";
const SubscriptionButton = () =>
  import("~/components/Cafe/SubscriptionButton.vue");
const TrialButton = () => import("~/components/Cafe/TrialButton.vue");
import CustomerSupport from "~/components/Common/CustomerSupport.vue";

export default {
  components: {
    CheckIcon,
    PhoneIncomingIcon,
    ChatAltIcon,
    PlayIcon,
    SubscriptionButton,
    TrialButton,
    CustomerSupport,
  },

  layout: "default",

  fetchOnServer: false,

  head() {
    return {
      title: this.metaTitle,
      meta: [
        { hid: "title", name: "title", content: this.metaTitle },
        { hid: "description", name: "description", content: this.metaDesc },
        { hid: "image", name: "image", content: this.metaImage },
        { hid: "og:url", property: "og:url", content: this.routePath },
        { hid: "og:title", property: "og:title", content: this.metaTitle },
        { hid: "og:image", property: "og:image", content: this.metaImage },
        {
          hid: "og:image:secure_url",
          property: "og:image:secure_url",
          content: this.metaImage,
        },
        {
          hid: "og:image:secure",
          property: "og:image:secure",
          content: this.metaImage,
        },
        {
          hid: "og:image:alt",
          property: "og:image:alt",
          content: this.metaTitle,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.metaDesc,
        },
        {
          hid: "twitter:title",
          name: "twitter:title",
          content: this.metaTitle,
        },
        {
          hid: "twitter:image:alt",
          name: "twitter:image:alt",
          content: this.metaTitle,
        },
        {
          hid: "twitter:description",
          name: "twitter:description",
          content: this.metaDesc,
        },
        {
          hid: "twitter:image",
          name: "twitter:image",
          content: this.metaImage,
        },
      ],
      link: [
        {
          hid: "canonical",
          rel: "canonical",
          href: `${this.canonical}`,
        },
      ],
      script: [
        {
          innerHTML: `{
            "@context": "http://schema.org",
            "@type": "NewsArticle",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "${this.routePath}"
            },
            "headline": "${this.metaTitle}",
            "image": "${this.metaImage}",
            "datePublished": "${this.datePublished}",
            "dateModified": "${this.datePublished}",
            "author": {
              "@type": "Person",
              "name": "${this.$$siteMeta}",
              "url": "${this.routePath}"
            },
            "publisher": {
              "@type": "Organization",
              "name": "${this.$$siteMeta}",
              "logo": {
                "@type": "ImageObject",
                "url": "${this.metaImage}"
              }
            }
          }`,
          type: "application/ld+json",
        },
      ],
      __dangerouslyDisableSanitizers: ["script"],
    };
  },
  data() {
    return {
      plans: [],
      plansLoading: false,
      model: {
        userPlan: "",
      },
    };
  },

  async fetch() {
    await this.getPlans();
  },

  computed: {
    customer() {
      return this.$get(this.$$users, "user", "");
    },

    datePublished() {
      return new Date().toISOString();
    },
    metaTitle() {
      return `${this.$t("meta.invoice.title_package")} | ${this.$$siteMeta}`;
    },

    metaDesc() {
      return `${this.$t("common.upgrade_desc")} | ${this.$$siteMeta}`;
    },

    metaImage() {
      return `${this.$config.protocol}://${this.$config.baseHost}/images/metacanhanf.jpeg`;
    },

    routePath() {
      return `http://${this.$config.baseHost}${this.$nuxt.context.route?.fullPath}`;
    },

    canonical() {
      return `https://${this.$config.baseHost}${this.$nuxt.context.route?.fullPath}`;
    },

    selectedPlan() {
      return (
        (this.plans || []).filter(({ id }) => this.model.userPlan === id)[0] ||
        {}
      );
    },

    selectedPlanPrice() {
      return this.selectedPlan ? this.selectedPlan?.final_price : 0;
    },

    hasDiscount() {
      const price = this.selectedPlan.original_price;
      const final = this.selectedPlan.final_price;
      return price > 0 && final > 0 && final < price;
    },

    discountPercent() {
      return this.selectedPlan.discount_percent;
    },

    formattedFinalPrice() {
      return `${this.selectedPlan.final_price}$`;
    },

    formattedOriginalPrice() {
      return `${this.selectedPlan.original_price}$`;
    },

    formattedDiscountAmount() {
      return `${(
        this.selectedPlan.original_price - this.selectedPlan.final_price
      ).toFixed(1)}$`;
    },

    currentSubscription() {
      return this.$$subscriptions || {};
    },

    activePlan() {
      return this.$get(this.currentSubscription, "status") === 'active';
    },

    // User registered a package successfully
    registered() {
      return !!this.$$subscriptions?.status;
    },

    canNotRegister() {
      return this.$$subscriptions?.status;
    },
  },

  methods: {
    // Currently support plan monthly, 6 months, yearly
    async getPlans() {
      this.plansLoading = true;
      try {
        const { data } = await this.$axios.request({
          url: "/api/polar/plans/",
          method: "get",
        });

        this.plans = data || [];

        if (this.plans && this.plans.length > 0) {
          const foundPlan = this.plans.find(
            (item) => item.id === this.currentSubscription.polar_plan_id
          );

          if (foundPlan) {
            this.model.userPlan = foundPlan?.id;
          } else {
            this.model.userPlan = this.plans[0]?.id;
          }
        } else {
          this.model.userPlan = "";
        }
      } catch (e) {
        // Keep plans empty on failure and log a warning
        console.error("getPlans error", e);
        this.plans = [];
        this.model.userPlan = "";
      } finally {
        this.plansLoading = false;
      }
    },
  },
};
